import type {
  CreateUpdatePolicyRequestDto,
  GetPoliciesResponseDto,
  PolicyDto,
  RemovePolicyResponseDto,
} from 'shared/dtos/policies.dto';
import type { AppDispatch } from 'store';

import { createAsyncThunk } from '@reduxjs/toolkit';
import PoliciesService from 'services/policies.service';
import { MODAL_POLICY } from 'shared/constants/modals';
import { closeModal } from 'store/modals/modals.slice';

const policiesService = new PoliciesService();

export const getPoliciesThunk = createAsyncThunk<GetPoliciesResponseDto>(
  'policies/getPolicies',
  async (_, thunkAPI) => {
    try {
      return await policiesService.getPolicies();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const getPolicyThunk = createAsyncThunk<PolicyDto, number>(
  'policies/getPolicy',
  async (id, thunkAPI) => {
    try {
      return await policiesService.getPolicy(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);
export const createPolicyThunk = createAsyncThunk<
  PolicyDto,
  CreateUpdatePolicyRequestDto,
  { dispatch: AppDispatch }
>('policies/createPolicy', async (data, thunkAPI) => {
  try {
    const result = await policiesService.createPolicy(data);
    thunkAPI.dispatch(getPoliciesThunk());
    thunkAPI.dispatch(closeModal({ name: MODAL_POLICY }));
    return result;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const removePolicyThunk = createAsyncThunk<
  RemovePolicyResponseDto,
  number
>('policies/removePolicy', async (id, thunkAPI) => {
  try {
    const result = await policiesService.removePolicy(id);
    thunkAPI.dispatch(getPoliciesThunk());
    return result;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updatePolicyThunk = createAsyncThunk<
  PolicyDto,
  CreateUpdatePolicyRequestDto & { id: number }
>('policies/updatePolicy', async (payload, thunkAPI) => {
  try {
    const { id, ...data } = payload;
    const result = await policiesService.updatePolicy(id, data);
    thunkAPI.dispatch(getPoliciesThunk());
    return result;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});
